import AvailabilityFetchVM from '@Components/ArrivalDeparturePicker/Types/AvailabilityFetchTSVM';

export default class AvailabilityContainer {

    data: AvailabilityFetchVM | undefined;

    
}